import { Injectable } from '@angular/core';
import { FileDownloadService } from '../file-download.service';
import { Observable, EMPTY } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class WebFileDownloadService extends FileDownloadService {

  constructor(private http: HttpClient) {
    super();
  }

  // downloadAndOpen(url: string, filename: string, content_type: string, skipAuth: boolean = false): Observable<any> {
  //   window.open(url, '_blank');
  //   return EMPTY;
  // }
  downloadAndOpen(url: string, filename: string, content_type: string, skipAuth: boolean = false): Observable<any> {

    this.http.get(url, { responseType: 'blob' }).subscribe((blob: Blob) => {
      const downloadLink = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = filename;

      // This line is required for Firefox browser
      downloadLink.style.display = 'none';

      document.body.appendChild(downloadLink);
      downloadLink.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(downloadLink);
    });
    return EMPTY;
  }
}
